/// THIS FILE IS AUTOGENERATED!!! DO NOT EDIT MANUALLY!!!
/// INSTEAD, USE A VITE PLUGIN OR RUN `php artisan bridge:generate:enumerations` COMMAND.

export const ProductType = {
  SIMPLE: 'SIMPLE',
  VARIANT: 'VARIANT',
  MULTIPACK: 'MULTIPACK',
  SET: 'SET',
  FLEXIBLE: 'FLEXIBLE',
} as const;

export type ProductType = typeof ProductType[keyof typeof ProductType];
